import React from 'react';
import Alert from '@mui/material/Alert';

const NodeEditorStatusAlert = ({
  message,
  severity = 'error',
  testId,
  sx = {},
}) => {
  const normalizedMessage = String(message || '').trim();
  if (!normalizedMessage) {
    return null;
  }

  return (
    <Alert
      data-testid={testId}
      severity={severity}
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: '10px',
        alignItems: 'center',
        '& .MuiAlert-icon': {
          py: 0,
          alignItems: 'center',
        },
        '& .MuiAlert-message': {
          py: 0,
          minHeight: 24,
          display: 'flex',
          alignItems: 'center',
          lineHeight: 1.45,
        },
        ...(severity === 'error' ? {
          borderColor: 'rgba(211, 47, 47, 0.35)',
          backgroundColor: 'rgba(211, 47, 47, 0.06)',
        } : {}),
        ...sx,
      }}
    >
      {normalizedMessage}
    </Alert>
  );
};

export default NodeEditorStatusAlert;
